module.exports = __webpack_public_path__ + "img/chart.18368fd5.svg";